// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from '@/store'   
import axios from 'axios'
import Vant from 'vant';
import 'vant/lib/index.css';
import '@/assets/scss/index.scss'
import './progress' // 路由控制
import { ComTools, DateTools } from '@/utils/tools'
Vue.config.productionTip = false
Vue.prototype.$ComTools = ComTools;
Vue.prototype.$DateTools = DateTools;
Vue.http = Vue.prototype.$http = axios
Vue.use(Vant);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js